import { forwardRef, ReactNode } from 'react';
import { alpha, Box } from '@mui/material';

export type StatusPillTone = 'neutral' | 'primary' | 'success' | 'info' | 'warning' | 'error';

interface StatusPillProps {
    tone: StatusPillTone;
    children: ReactNode;
    title?: string;
    dataTest?: string;
}

const StatusPill = forwardRef<HTMLSpanElement, StatusPillProps>(function StatusPill(
    { tone, children, title, dataTest, ...rest },
    ref,
) {
    return (
        <Box
            {...rest}
            ref={ref}
            component="span"
            data-test={dataTest}
            title={title}
            sx={(theme) => {
                // The neutral palette is app-theme only; a bare MUI theme falls back to secondary text.
                const main = theme.palette[tone]?.main ?? theme.palette.text.secondary;
                return {
                    display: 'inline-flex',
                    alignItems: 'center',
                    height: 22,
                    px: 1.25,
                    borderRadius: '999px',
                    fontSize: 12,
                    fontWeight: 500,
                    whiteSpace: 'nowrap',
                    bgcolor: alpha(main, 0.12),
                    color: tone === 'neutral' ? 'text.secondary' : theme.palette[tone].dark,
                };
            }}
        >
            {children}
        </Box>
    );
});

export default StatusPill;
